import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useHistory, Redirect } from 'react-router-dom';
import { ApplicationState } from 'store';
import { AcademyState } from 'store/modules/academy_store/types';
import { ProfileState } from 'store/modules/profile_store/types';
import {
  getAgenda,
  getLiveNow,
  getContents,
  getMySubscriptions,
} from 'store/modules/academy_store/actions';
import AcademyAgenda from 'components/organisms/academy_agenda';
import AcademyContents from 'components/organisms/academy_contents';
import AcademyMyTrainings from 'components/organisms/academy_my_trainings';
import AcademyLive from 'components/organisms/academy_live';
import AcademyContentDetail from 'components/organisms/academy_content_detail';
import AcademyEventDetail from 'components/organisms/academy_event_detail';
import CalendarIcon from 'assets/images/icon_calendar_summary.svg';
import SheetIcon from 'assets/images/icon_sheet_summary.svg';
import TrainingIcon from 'assets/images/icon_starred_seet_summary.svg';
import { Container } from './styles';

const LEFT_TABS = [
  { key: 'calendario', label: 'Calendário', icon: CalendarIcon },
  { key: 'conteudos', label: 'Conteúdos', icon: SheetIcon },
  { key: 'meus-treinamentos', label: 'Meus Treinamentos', icon: TrainingIcon },
];

const Academy: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { tab, id } = useParams<{ tab?: string; id?: string }>();
  const { liveNow } = useSelector<ApplicationState, AcademyState>((s) => s.session.academy);
  const { profile } = useSelector<ApplicationState, ProfileState>((s) => s.storage.profile);
  const isAlfaTester = Boolean(profile?.alfa_tester);
  const activeTab = tab || (liveNow ? 'ao-vivo' : 'calendario');
  const detailId = id ? Number(id) : null;

  useEffect(() => {
    // Fase alfa: só carrega os dados para clientes alfa_testers.
    if (!isAlfaTester) return;
    document.title = 'Conlicitação Academy';
    dispatch(getLiveNow());
    dispatch(getAgenda());
    dispatch(getContents());
    dispatch(getMySubscriptions());
  }, [dispatch, isAlfaTester]);

  // Acesso direto pela URL: clientes fora do alfa vão para o painel.
  if (!isAlfaTester) return <Redirect to="/painel" />;

  const goToTab = (key: string) => history.push(`/academy/${key}`);

  const renderTab = (item: { key: string; label: string; icon: string }) => (
    <button
      key={item.key}
      type="button"
      className={`academy-tab ${item.key} ${activeTab === item.key ? 'active' : ''}`}
      onClick={() => goToTab(item.key)}
    >
      <img className="academy-tab-icon" src={item.icon} alt="" />
      {item.label}
    </button>
  );

  return (
    <Container className="page-container">
      <div className="academy-topbar">
        <div className="container-fluid big-resolutions">
          <h1 className="academy-heading">Conlicitação Academy</h1>
          <div className="academy-tabs">
            {LEFT_TABS.map(renderTab)}
            <div className="tabs-right">
              <button
                type="button"
                disabled={!liveNow}
                className={`academy-tab ao-vivo ${activeTab === 'ao-vivo' ? 'active' : ''} ${
                  liveNow ? 'is-live' : 'blocked'
                }`}
                onClick={() => liveNow && goToTab('ao-vivo')}
                title={
                  liveNow ? 'Assistir à transmissão ao vivo' : 'Nenhuma transmissão no momento'
                }
              >
                {liveNow ? (
                  <span className="ao-vivo-dot" />
                ) : (
                  <i className="material-icons ao-vivo-icon">radio_button_checked</i>
                )}
                Ao Vivo
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="academy-content">
        <div className="container-fluid big-resolutions">
          {detailId && activeTab === 'calendario' && <AcademyEventDetail id={detailId} />}
          {detailId && activeTab === 'conteudos' && (
            <AcademyContentDetail id={detailId} source="conteudos" />
          )}
          {detailId && activeTab === 'meus-treinamentos' && (
            <AcademyContentDetail id={detailId} source="meus-treinamentos" />
          )}

          {!detailId && activeTab === 'calendario' && <AcademyAgenda />}
          {!detailId && activeTab === 'conteudos' && <AcademyContents />}
          {!detailId && activeTab === 'meus-treinamentos' && <AcademyMyTrainings />}
          {activeTab === 'ao-vivo' && <AcademyLive />}
        </div>
      </div>
    </Container>
  );
};

export default Academy;
